export default __webpack_public_path__ + "static/media/GalleryBackg.5e6d5706.jpg";